module.exports = __webpack_public_path__ + "static/media/tombolan.990ec761.png";